// extracted by mini-css-extract-plugin
export default {"body_styleDefault":"c-a_fK","body_styleRed":"c-a_fL"};